import { Injectable } from '@angular/core';

import { PaymentMethod } from '../../../../../../../../data/dietitian/domain/subscription/payment_method';
import { SubscriptionCommands } from '../../../../../../../../data/dietitian/domain/subscription/subscription_commands';

@Injectable()
export class FeatureSubscriptionConfirmationPopupFacade {
  constructor(private subscriptionCommands: SubscriptionCommands) {
    // Nada
  }

  async getPaymentMethods(): Promise<PaymentMethod[]> {
    return this.subscriptionCommands.getPaymentMethods();
  }
}
